import { mapState } from 'vuex';
import tenantPickerMixin from '@/components/core/tenant/pickerMixin';
import ApiService from '@/services/apiService';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import { get } from 'lodash';
export default {
  name: 'CoreDialogEula',
  components: {
    MarkdownItVueLight
  },
  mixins: [tenantPickerMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      termsAndConditions: '',
      title: ''
    };
  },
  computed: {
    ...mapState('app', ['color'])
  },
  watch: {
    open(value) {
      if (value) {
        this.loadTermsAndConditions();
      }
    },
    userId() {
      if (this.open) {
        this.loadTermsAndConditions();
      }
    },
    '$store.state.app.language'() {
      if (this.open) {
        this.loadTermsAndConditions();
      }
    }
  },
  methods: {
    loadTermsAndConditions() {
      if (!this.userId) {
        this.termsAndConditions = '';
        this.title = '';
        return;
      }
      const tenantId = get(this, '$store.state.authentication.tenantId') || get(this, '$store.state.authentication.primaryTenantIds[0]') || get(this, '$store.state.authentication.user.tenantId');
      if (!tenantId) {
        this.termsAndConditions = '';
        this.title = '';
        return;
      }
      ApiService.getTermsAndConditions(tenantId).then(result => {
        this.termsAndConditions = get(result, `termsAndConditions[0].termsAndConditions[${this.$store.state.app.language || 'de'}]`, '');
        this.title = get(result, `termsAndConditions[0].termsAndConditions.title[${this.$store.state.app.language || 'de'}]`, '');
      }).catch(error => {
        this.termsAndConditions = '';
        this.title = '';
        console.error(error);
      });
    },
    handleAccept() {
      ApiService.userAcceptEula().then(() => {
        this.$store.dispatch('authentication/verify').catch(() => {
          this.$snack('Error while accepting the agreement', 'error');
        });
      }).catch(() => {
        this.$snack('Error while accepting the agreement', 'error');
        this.handleDecline();
      });
    },
    handleDecline() {
      this.$store.dispatch('authentication/logout').then(() => {
        this.$router.push('/login');
      }).catch(() => {
        // empty
      });
    }
  }
};